import React from "react";
import "../styles/MobileBanking.css";
import SahyadriBankBanner from '../pages/SahyadriBankBanner';
import QrImg from "../assets/photos/qr.png"
import {
    FaMobileAlt,
    FaHistory,
    FaLock,
    FaShieldAlt
} from "react-icons/fa";

const APK_LINK =
    "https://drive.google.com/uc?export=download&id=1zf6rDxmwEUNtREW3F-QiGDS02ee7ndw5";

function MobileBanking() {

    const handleQRClick = () => {
        if (window.innerWidth <= 768) {
            window.location.href = APK_LINK;
        }
    };

    return (
        <div className="mobile-page">

            {/* HERO */}
            <section className="mobile-hero">
                <div className="hero-inner">
                    <div className="hero-text">
                        <h1>
                            Simple & Secure <span>Mobile Banking</span>
                        </h1>
                        <p>
                            Stay connected with your bank anytime, anywhere.
                            Instantly check your balance and view transaction
                            history with complete security.
                        </p>
                    </div>
                </div>
            </section>

            <section className="mb-intro">
                <h2>Your Bank, Always in Your Pocket</h2>
                <h3>Check your balance, track your transactions, and stay on top of your finances — anytime, anywhere.</h3>
                <h4>Check Your Balance</h4>
                <p>No more waiting in queues or calling customer care. With our mobile banking app, your account balance is always just a tap away. Whether you hold a savings account, current account, or fixed deposit, you can view all your balances in one place, in real time. Get a clear picture of your available balance versus your total balance, and monitor all your accounts from a single, easy-to-use dashboard — securely and instantly.</p>
                <h4>Transaction History</h4>
                <p>Get a complete and detailed record of all your account activity. From your most recent transaction to months ago, your full transaction history is always accessible, clear, and easy to understand. Easily filter transactions by date, amount, or type to find exactly what you are looking for. You can also download or export your statements as a PDF for record-keeping or tax purposes. With a clean and organized view of all credited and debited amounts, you will always know where every rupee goes.</p>
            </section>

            <section>
            <div style={{ maxWidth: '960px', margin: '0 auto' }}>
              <SahyadriBankBanner />
            </div>
            </section>

            {/* FEATURES */}
            <section className="mobile-features">

                <div className="feature-card">
                    <FaMobileAlt />
                    <h3>Instant Balance Check</h3>
                    <p>View your real-time account balance anytime.</p>
                </div>

                <div className="feature-card">
                    <FaHistory />
                    <h3>Transaction History</h3>
                    <p>Access recent transactions instantly.</p>
                </div>

                <div className="feature-card">
                    <FaLock />
                    <h3>Secure MPIN Login</h3>
                    <p>Protected with 6-digit MPIN authentication.</p>
                </div>

                <div className="feature-card">
                    <FaShieldAlt />
                    <h3>Safe & Reliable</h3>
                    <p>No online payments. Reduced fraud risk.</p>
                </div>
            </section>


            {/* QR SECTION (UNCHANGED STRUCTURE) */}
            <section className="qr-section">
                <div className="qr-container">

                    <div className="qr-image" onClick={handleQRClick}>
                        <img
                            src={QrImg}
                            alt="Scan to Download"
                        />
                    </div>

                    <div className="qr-content">
                        <h2>Download via QR Code</h2>
                        <ul>
                            <li>Use your registered mobile number.</li>
                            <li>Scan the QR code to download the app.</li>
                            <li>Enter your account number.</li>
                            <li>Verify OTP sent to your mobile.</li>
                            <li>Set your 6-digit MPIN.</li>
                        </ul>

                        <div className="qr-instruction">
                            📱 On mobile devices, tap the QR to start download directly.
                        </div>
                    </div>

                </div>
            </section>

            {/* IMPROVED SECURITY SECTION */}
            <section className="security-section">
                <h2>Your Security is Our Priority</h2>

                <div className="security-grid">

                    <div className="security-card">
                        <FaShieldAlt />
                        <p>OTP verification during registration</p>
                    </div>

                    <div className="security-card">
                        <FaShieldAlt />
                        <p>Access only via registered mobile number</p>
                    </div>

                    <div className="security-card">
                        <FaShieldAlt />
                        <p>Secure 6-digit MPIN authentication</p>
                    </div>

                    <div className="security-card">
                        <FaShieldAlt />
                        <p>Safe internal banking application</p>
                    </div>

                </div>
            </section>

        </div>
    );
}

export default MobileBanking;